export default __webpack_public_path__ + "static/media/repairs.f66a7dcc.jpg";